import React, { useContext, useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, InputAdornment, Modal, TextField, Typography } from '@mui/material';
import { Icons } from '../../../../assets/icons';
import {
  TCategoryType,
  getCategoryColor,
  getGroupByCategory,
  getGroupByCategoryWithSectionName
} from '../../../../shared/Constants';
import { LaundryCartContext } from '../../context/service.context';
import './categorywidget.scss';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';
import { CartList } from '../cart-list/CartList';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 300,
  bgcolor: 'background.paper',
  outline: 'none',
  justifyContent: 'center',
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  p: '0',
};

const CategoryWidget = () => {
  const { data, setData } = useContext(LaundryCartContext);
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [ clothesFilterList, setClothesFilterList] = useState<any>([]);
  const [ selectService, setSelectService] = useState(clothesFilterList[0]);
  const [searchInput, setSearchInput] = useState('');
  const [searchQueries, setSearchQueries] = useState<any>({});
  const [expanded, setExpanded] = useState<string | boolean>(false);
  const [clothesList, setClothesList] = useState<any>([]);
  const [openDimensionDialog, setOpenDimensionDialog] = useState(false);
  const [activeDimensionItem, setActiveDimensionItem] = useState<any>(null);
  const [itemSizeForm, setItemSizeForm] = useState({
    length: '0.0',
    width: '0.0',
  });
  const handleCountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    // 1. Allow the user to clear the input temporarily so they can type a new number
    if (value === '') {
      setItemSizeForm((prev) => ({ ...prev, [name]: '' }));
      return;
    }

    // 2. If they type a number after a default '0', replace the zero
    let cleanValue = value;
    if ((cleanValue.startsWith('0.0') || cleanValue === '0') && cleanValue.length > 1) {
      const lastChar = value.slice(-1);
      // If the last character typed is a valid number, make it the new value
      if (!isNaN(Number(lastChar)) && lastChar !== '.') {
        cleanValue = lastChar;
      }
    }

    setItemSizeForm((prev) => ({
      ...prev,
      [name]: cleanValue,
    }));
  };
  const handleExpanded = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean)  => {
    setExpanded(isExpanded ? panel : false)
  }
  useEffect(() => {
    setSelectedItem(null);
      const filterList = Object.keys(getGroupByCategory(data));
      setClothesFilterList(filterList);
      if (filterList.length > 0 && !selectService) {
        setSelectService(filterList[0]);
      }
  }, [data]);

  useEffect(() => {
    if (selectedItem) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [selectedItem]);

   useEffect(() => {
    if (clothesFilterList.length > 0) {
      const isService = clothesFilterList.includes(selectService);
      handleFilterService(isService ? selectService : clothesFilterList[0]);
    }
 },[selectService, clothesFilterList]);

  const handleModalClose = (event: any, reason: any) => {
    if (reason && reason === 'backdropClick') return;
  };

  const increaseQuantity = (id: any) => {
    const currentItems = [...data];
    const index = currentItems.findIndex((itemDetail: any) => itemDetail.id === id);
    if (index !== -1) {
      let currentQty = currentItems[index].quantity;
      // If it's pricing type 2 and currently sitting at 0, treat its baseline as 1
      if (currentItems[index].pricingType === 2 && currentQty === 0) {
        currentQty = 1;
      }
      currentItems[index].quantity = currentQty + 1;
      setData(currentItems);
    }
  };

  const decreaseQuantity = (id: any) => {
    const currentItems = [...data];
    const index = currentItems.findIndex((itemDetail: any) => itemDetail.id === id);
    if (index !== -1) {
      const currentQty = currentItems[index].quantity;
      // Rule: Pricing type 2 items cannot drop below 1
      if (currentItems[index].pricingType === 2) {
        if (currentQty <= 1) {
          currentItems[index].quantity = 1;
          setData(currentItems);
          return;
        }
      }
      if (currentQty > 0) {
        currentItems[index].quantity = currentQty - 1;
        setData(currentItems);
      }
    }
  };

  const itemChangeHandler = (event: React.ChangeEvent<HTMLInputElement>, item: any) => {
    const { value } = event.target;
    let quantity = parseInt(value, 10);

    // Fallback protection check against NaN or negative bounds
    if (isNaN(quantity) || quantity < 0) {
      quantity = item.pricingType === 2 ? 1 : 0;
    }
    
    // Fallback if they manually type 0 for pricing type 2
    if (item.pricingType === 2 && quantity === 0) {
      quantity = 1;
    }

    const currentItems = [...data];
    const index = currentItems.findIndex((itemDetail: any) => itemDetail.id === item.id);
    if (index !== -1) {
      currentItems[index].quantity = quantity;
      setData(currentItems);
    }
  };

  const handleSave = () => {
  if (!activeDimensionItem) return;

  // 1. Parse inputs cleanly
  const length = parseFloat(itemSizeForm.length) || 0;
  const width = parseFloat(itemSizeForm.width) || 0;
  
  // 2. Calculate using raw numbers first
  let calculatedSize = length * width;

  // 3. Fallback for NaN or negative values
  if (isNaN(calculatedSize) || calculatedSize < 0) {
    calculatedSize = 0.0;
  }

  // 4. Format to 2 decimal places, then convert back to a number
const formattedItemSize = parseFloat(calculatedSize.toFixed(2));

  // 5. Update state safely without mutating original objects
  const index = data.findIndex((itemDetail: any) => itemDetail.id === activeDimensionItem.id);
  
  if (index !== -1) {
    const currentItems = [...data];
    
    // Create a shallow copy of the specific object we are modifying
    currentItems[index] = {
      ...currentItems[index],
      itemSize: formattedItemSize,
    };
    
    // If dimension size is modified and pricingType is 2, ensure quantity clicks up to 1
    if (currentItems[index].pricingType === 2 && currentItems[index].quantity === 0) {
      currentItems[index].quantity = 1;
    }
    setData(currentItems);
  }

  // 6. Reset UI State
  setOpenDimensionDialog(false);
  setActiveDimensionItem(null);
};
  const handleFilterService = (clothList: any) => {
    setSelectService(clothList);
    const list: any = getGroupByCategoryWithSectionName(data)[clothList] || [];
    setClothesList(list);
  };

  const handleSearchInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchInput(event.target.value);
  };

  const handleSearchInputChangeAccordion = (sectionName: any, event: any) => {
    setSearchQueries({
      ...searchQueries,
      [sectionName]: event?.target?.value.toLowerCase()
    });
  };

  const filteredClothesList = clothesList?.map((section: any) => ({
    ...section,
    optiServiceItem: section.optiServiceItem.filter((item: any) => 
      item.item?.toLowerCase().includes(searchQueries[item.serviceItemSectionName] || '')
    )
  }));

  const filteredOptiServiceItem = clothesList?.map((section: any) => ({
    ...section,
    optiServiceItem: section.optiServiceItem.filter((item: any) => 
      item.itemCode?.toLowerCase().includes(searchInput?.toLowerCase()) || 
      item.item?.toLowerCase().includes(searchInput?.toLowerCase())
    )
  }));

  return (
    <>
      <Grid container spacing={1} padding={'0px 10px 10px 0px'}>
        {clothesFilterList?.length > 0 ? (clothesFilterList?.map((item: string, index: number) => (
            <Grid item key={index}>
                <Chip
                    color="primary"
                    size="medium"
                    variant={selectService === item ? "filled" : "outlined"}
                    sx={{color: selectService === item ? 'white' : 'primary'}}
                    label={item}
                    onClick={() => handleFilterService(item)}
                />
            </Grid>
        ))) : (
          <Typography variant="subtitle1" color={'GrayText'} sx={{ fontSize: '14px', padding: '30px 40%' }}>
            No Items to show
          </Typography>
        )}
        {filteredOptiServiceItem?.length === 1 ? (
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              placeholder="Search Item code"
              id="inputSearchItems"
              value={searchInput}
              onChange={handleSearchInputChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              fullWidth
              sx={{ '& .MuiOutlinedInput-root': { '& input': { padding: '8px 14px' } } }}
            />
          </Grid>
        ) : null}
      </Grid>
      
      <div style={{ height: '100%', overflow: 'auto', padding: '5px 20px' }}>
        {filteredOptiServiceItem?.length === 1 ? filteredOptiServiceItem?.map(
          (item: any, index: number) => (
            <CartList
              filteredClothesList={item.optiServiceItem}
              index={item?.id}
              name={item?.item}
              price={item?.price}
              type={item?.category as TCategoryType}
              currency={item?.currency}
              icon={item?.icon}
              key={`laundryTile${index}`}
              itemChangeHandler={itemChangeHandler}
              count={item?.quantity}
              onIncrement={(i) => increaseQuantity(i)}
              onDecrement={(i) => decreaseQuantity(i)}
              setActiveDimensionItem={setActiveDimensionItem}
              setOpenDimensionDialog={setOpenDimensionDialog}
            />
          )
        ) : filteredClothesList?.map(
          (item: any, index: number) => (
            <Accordion
              expanded={expanded === `panel${index}`}
              onChange={handleExpanded(`panel${index}`)}
              key={`panel${index}`}
              sx={{ backgroundColor: 'transparent', border: "1px solid purple", padding: '0.5rem 0.5rem', margin: '0.5rem 0rem' }}
            >
              <AccordionSummary sx={{ padding: '0px', textAlign: 'center' }} expandIcon={<ExpandMoreIcon />}>
                <Grid container display={'flex'} direction={'row'} justifyContent={'space-between'} alignItems="center">
                  <Grid item>
                    <DialogContentText sx={{ fontSize: '14px', color: 'black' }}>
                      {item?.serviceItemSectionName}
                    </DialogContentText>
                  </Grid>
                  <Grid item>
                    <TextField
                      variant="outlined"
                      placeholder="Search..."
                      id="inputSearchItem"
                      onClick={(e) => e.stopPropagation()} // Keeps accordion header open during text selections
                      onChange={(e) => handleSearchInputChangeAccordion(item?.serviceItemSectionName, e)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      sx={{ '& .MuiOutlinedInput-root': { '& input': { padding: '8px 14px' } } }}
                    />
                  </Grid>
                </Grid>
              </AccordionSummary>
              <AccordionDetails sx={{ display: 'flex', flexDirection: 'column', padding: '0px' }}>
                <CartList
                  filteredClothesList={item.optiServiceItem}
                  index={item?.id}
                  name={item?.item}
                  price={item?.price}
                  type={item?.category as TCategoryType}
                  currency={item?.currency}
                  icon={item?.icon}
                  itemChangeHandler={itemChangeHandler}
                  count={item?.quantity}
                  onIncrement={(i) => increaseQuantity(i)}
                  onDecrement={(i) => decreaseQuantity(i)}
                  setActiveDimensionItem={setActiveDimensionItem}
                  setOpenDimensionDialog={setOpenDimensionDialog}
                />
              </AccordionDetails>
            </Accordion>
          )
        )}
      </div>

      <Modal open={open} onClose={handleModalClose} disableEnforceFocus>
        <Box sx={{ ...modalStyle }} className="cart-modal" style={{ background: getCategoryColor(selectedItem?.category) }}>
          <IconButton
            className="cart-modal-close"
            onClick={() => {
              setOpen(false);
              setSelectedItem(null);
            }}
          >
            <img src={Icons.close} alt="closeIcon" id="closeIcon" />
          </IconButton>
          <Box className="cart-modal-info">
            <img src={selectedItem?.icon} className="cart-modal-img" width={'150px'} alt="icon" />
            <p className="cart-modal-name">{selectedItem?.item}</p>
            <p className="cart-modal-price">{selectedItem?.currency}{selectedItem?.price}</p>
          </Box>
          <ul className="cart-modal-actions">
            <li style={{ width: '25%' }}>
              <button className="cart-modal-actions-decrement-btn" onClick={() => decreaseQuantity(selectedItem.id)}>-</button>
            </li>
            <li style={{ width: '50%' }}>
              <input
                type="number"
                value={data[selectedItem?.id]?.quantity !== undefined ? data[selectedItem?.id]?.quantity : (data[selectedItem?.id]?.pricingType === 2 ? 1 : 0)}
                onChange={(e) => {
                  setData((pv: any) => {
                    const parsedValue = parseInt(e.target.value, 10);
                    pv[selectedItem.id].quantity = isNaN(parsedValue) || parsedValue < 0 ? (pv[selectedItem.id].pricingType === 2 ? 1 : 0) : parsedValue;
                    return [...pv];
                  });
                }}
              />
            </li>
            <li style={{ width: '25%' }}>
              <button className="cart-modal-actions-increment-btn" onClick={() => increaseQuantity(selectedItem.id)}>+</button>
            </li>
          </ul>
        </Box>
      </Modal>
      <Dialog 
        fullWidth
        maxWidth='sm'  
        open={openDimensionDialog} 
        onClose={() => {
          setOpenDimensionDialog(false);
          setActiveDimensionItem(null);
        }}
      >
        <DialogTitle textAlign="center">Add Dimensions</DialogTitle>
        <DialogContent>
          <div className='d-flex item-center justify-content-between' style={{ gap: '16px', marginTop: '8px' }}>
            <TextField
              className='mt-2'
              fullWidth
              key="length"
              label="Enter Length"
              name="length"
              type="number" 
              size='small'
              // If the state is empty, show '0.0' so it is NEVER blank to the user
              value={itemSizeForm.length === '' ? '0.0' : itemSizeForm.length}
              onChange={handleCountChange}
              // Highlight text on click so they don't have to manually delete '0.0'
              onFocus={(e) => { if (parseFloat(e.target.value) === 0) e.target.select(); }} 
              // If they click away while empty, snap it back to '0.0'
              onBlur={(e) => {
                if (e.target.value === '' || parseFloat(e.target.value) === 0) {
                  setItemSizeForm((prev) => ({ ...prev, length: '0.0' }));
                }
              }}
            />

            <TextField
              className='mt-2'
              fullWidth
              key="width"
              label="Enter Width"
              name="width"
              type="number" 
              size='small'
              // If the state is empty, show '0.0' so it is NEVER blank to the user
              value={itemSizeForm.width === '' ? '0.0' : itemSizeForm.width}
              onChange={handleCountChange}
              // Highlight text on click so they don't have to manually delete '0.0'
              onFocus={(e) => { if (parseFloat(e.target.value) === 0) e.target.select(); }}
              // If they click away while empty, snap it back to '0.0'
              onBlur={(e) => {
                if (e.target.value === '' || parseFloat(e.target.value) === 0) {
                  setItemSizeForm((prev) => ({ ...prev, width: '0.0' }));
                }
              }}
            />
          </div>
          <div className='d-flex item-center justify-content-center' style={{ gap: '16px', marginTop: '8px' }}>
            <span style={{ fontSize: '14px', fontWeight: 'bold' }}>{(parseFloat(itemSizeForm.length) * parseFloat(itemSizeForm.width)).toFixed(2)} sqm</span>
          </div>
        </DialogContent>
        <DialogActions className="dialog-btn py-3 px-4">
          <div style={{ flex: 1 }}>
            <Button
              color='primary'
              variant="contained"
              sx={{color: 'white'}}
              onClick={() => {
                setItemSizeForm({
                  length: '0.0',
                  width: '0.0',
                });
              }}
            >
              Reset
            </Button>
          </div>
            
          <Button 
            color='error' 
            variant="contained" 
            sx={{color: 'white'}} 
            onClick={() => {
              setOpenDimensionDialog(false);
              setActiveDimensionItem(null);
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            sx={{color: 'white'}}
            variant="contained"
            // Updated button protection conditions to handle safe fallback checks cleanly
            disabled={!itemSizeForm.length || !itemSizeForm.width || parseFloat(itemSizeForm.length) === 0 || parseFloat(itemSizeForm.width) === 0}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CategoryWidget;